import { render } from "./ProadminRegister.vue?vue&type=template&id=7ce77d60&scoped=true"
import script from "./ProadminRegister.vue?vue&type=script&lang=js"
export * from "./ProadminRegister.vue?vue&type=script&lang=js"

import "./ProadminRegister.vue?vue&type=style&index=0&id=7ce77d60&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce77d60"]])

export default __exports__